import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-analytics-charts/react-analytics-charts/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Props } from "docz";
import { ViewSelector } from "./ViewSelector";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>ViewSelector</h1>
    <h2 {...{
      "id": "description"
    }}>{`Description`}</h2>
    <p>{`The ViewSelector component allows you to choose your account, property, and view via dropdown menus.`}</p>
    <p>{`This component is rendered by the `}<a parentName="p" {...{
        "href": "https://justinmahar.github.io/react-use-analytics-api/"
      }}>{`Google Analytics Embed API`}</a>{` into a container on the page.`}</p>
    <p>{`This component wraps the `}<a parentName="p" {...{
        "href": "https://justinmahar.github.io/react-use-analytics-api/useViewSelector"
      }}><inlineCode parentName="a">{`useViewSelector`}</inlineCode></a>{` hook from `}<a parentName="p" {...{
        "href": "https://justinmahar.github.io/react-use-analytics-api/"
      }}>{`react-use-analytics-api`}</a>{`.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { ViewSelector } from "react-analytics-charts";
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const viewSelectionHandler = viewId => console.log(viewId);
...
<ViewSelector gapi={gapi} onChange={viewSelectionHandler} />
`}</code></pre>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={ViewSelector} mdxType="Props" />
    <blockquote>
      <p parentName="blockquote">{`Note: Expand each prop for more information.`}</p>
    </blockquote>
    <h2 {...{
      "id": "styling"
    }}>{`Styling`}</h2>
    <p>{`The view selector `}<inlineCode parentName="p">{`div`}</inlineCode>{` has the class name `}<inlineCode parentName="p">{`gapi-view-selector-container`}</inlineCode>{`. Inspect the DOM to see what Google renders there.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.gapi-view-selector-container {
  /* Custom styles */
}
`}</code></pre>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <p>{`The following example shows standalone use of a ViewSelector, including full authorization flow.`}</p>
    <p>{`You can also use this example to quickly determine the `}<inlineCode parentName="p">{`viewId`}</inlineCode>{` you'd like to provide to a chart or an `}<a parentName="p" {...{
        "href": "/react-analytics-charts/AnalyticsDashboard"
      }}>{`AnalyticsDashboard`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { useAnalyticsApi } from "react-use-analytics-api";
import * as React from "react";
import {
  AuthorizeButton,
  SignOutButton,
  ViewSelector,
} from "react-analytics-charts";

export function ViewSelectorExample() {
  const [viewId, setViewId] = React.useState("");
  const { gapi, authorized } = useAnalyticsApi();

  const viewIdStyles = {
    border: "solid 2px orange",
    margin: "10px",
    padding: "5px",
  };

  return (
    <div>
      {!authorized && (
        <AuthorizeButton
          gapi={gapi}
          authOptions={{
            clientId:
              "123456789012-abc123def456ghi789jkl012mno345p.apps.googleusercontent.com",
          }}
        />
      )}
      {authorized && (
        <div>
          <h2>
            Selected view ID:
            <code style={viewIdStyles}>{viewId}</code>
          </h2>
          <p>
            <SignOutButton gapi={gapi} />
          </p>
          <ViewSelector gapi={gapi} onChange={(viewId) => setViewId(viewId)} />
        </div>
      )}
    </div>
  );
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      